import React from 'react';
import cn from 'classnames';
import styles from './Developer.scss';
import { useTranslation } from 'react-i18next';

const Developer = ({ className, building, print }) => {
  const { builder, contractor, commission, count_flats, commission_note } = building.data;
  const { t } = useTranslation();
  const renderRow = (person, title) =>
    person
      ? person
          .filter(({ name }) => name)
          .map(({ name }) => (
            <div key={name} className={styles.Row}>
              <div className={styles.Name}>{name}</div>
              {title && <div className={styles.Label}>{title}</div>}
            </div>
          ))
      : [];

  const arr = [
    ...renderRow(builder),
    ...renderRow(contractor, t('components.building.main.developer.contractor')),
  ];

  return (
    <div className={cn({ [styles.DeveloperPrintWrap]: print })}>
      <div className={cn(styles.Developer, className, { [styles.DeveloperPrint]: print })}>
        <h3 className={styles.Title}>{t('components.building.main.developer.developer')}</h3>
        <div className={styles.Inner}>
          {arr.length ? (
            arr
          ) : (
            <div className={styles.Row}>
              <div className={styles.Label}>{t('components.building.main.developer.noInfo')}</div>
            </div>
          )}
        </div>
      </div>
      <div>
        {commission_note ? (
          <div className={cn(styles.Developer, className, { [styles.DeveloperPrint]: print })}>
            <h3 className={styles.Title}>{t('components.building.main.developer.note')}</h3>
            <div className={styles.CommissionInner}>
              <div className={styles.Row}>
                <div
                  style={{ whiteSpace: 'pre-wrap' }}
                  className={cn(styles.Name, styles.Commission)}
                >
                  {commission_note}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div>
        {commission && count_flats ? (
          <div className={cn(styles.Developer, className, { [styles.DeveloperPrint]: print })}>
            <h3 className={styles.Title}>{t('components.building.main.developer.commission')}</h3>
            <div className={styles.CommissionInner}>
              <div className={styles.Row}>
                <div
                  style={{ whiteSpace: 'pre-wrap' }}
                  className={cn(styles.Name, styles.Commission)}
                >
                  {commission}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Developer;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Developer/Developer.js